// extracted by mini-css-extract-plugin
module.exports = {"title":"style_title__VJGg6","sm":"style_sm__fI_bB","md":"style_md__tEuBB","lg":"style_lg___IlF9","xl":"style_xl__IttXv"};